import React from "react";
import styled from "styled-components";

interface Props {
  children?: React.ReactElement | React.ReactElement[] | null;
}

const ErrorWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  min-height: 500px;
`;

const ErrorContainerElem = styled.div`
  padding: 10px;
  text-align: center;

  a {
    text-decoration: underline;
  }

  @media screen and (max-width: 960px) {
    & {
      flex-direction: column;
    }
  }
`;

export function ErrorContainer(props: Props): JSX.Element {
  const { children } = props;
  return (
    <ErrorWrapper>
      <ErrorContainerElem>{children}</ErrorContainerElem>
    </ErrorWrapper>
  );
}
